import { Item } from './Item';
import { Container } from './styled';

export const Toast = {
  Container,
  Item,
};
